/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { LIST_REPORT9 } from "./actionTypes"
import { listReport9Error, listReport9Success } from "./actions"

//Include Both Helper File with needed methods
import { report9NewApi } from "../../../helpers/backend_helper"

function* list(request) {
  try {
    const response = yield call(report9NewApi, request.payload.form)
    if (response === undefined) throw new Error("API error")
    yield put(listReport9Success(response))
  } catch (error) {
    console.log(error.message)
    yield put(listReport9Error(error.message))
  }
}

function* report9ListSaga() {
  yield takeEvery(LIST_REPORT9, list)
}

export default report9ListSaga
